
import { useEffect, useState } from "react";
import { StickyLoanSummary } from "@/components/loan/StickyLoanSummary";

interface StickyHeaderProps {
  loanAmount: number;
  loanTerm: number;
  monthlyPayment: number;
}

export const StickyHeader = ({ loanAmount, loanTerm, monthlyPayment }: StickyHeaderProps) => {
  const [isSticky, setIsSticky] = useState(false);
  
  // Handle scroll to make payment info sticky
  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 300);
    };
    
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <StickyLoanSummary 
      isSticky={isSticky}
      loanAmount={loanAmount}
      loanTerm={loanTerm}
      monthlyPayment={monthlyPayment}
    />
  );
};
